/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Browser({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3.402 1.602a1.8 1.8 0 0 0-1.8 1.8v9.2a1.8 1.8 0 0 0 1.8 1.8h9.2a1.8 1.8 0 0 0 1.8-1.8v-9.2a1.8 1.8 0 0 0-1.8-1.8zm-.6 4.8v6.2a.6.6 0 0 0 .6.6h9.2a.6.6 0 0 0 .6-.6v-6.2zm1.2-3a.6.6 0 0 0-.6.6v.008a.6.6 0 0 0 .6.6h.008a.6.6 0 0 0 .6-.6v-.008a.6.6 0 0 0-.6-.6zm1.8.6a.6.6 0 0 1 .6-.6h.008a.6.6 0 0 1 .6.6v.008a.6.6 0 0 1-.6.6h-.008a.6.6 0 0 1-.6-.6zm3-.6a.6.6 0 0 0-.6.6v.008a.6.6 0 0 0 .6.6h.008a.6.6 0 0 0 .6-.6v-.008a.6.6 0 0 0-.6-.6z" clipRule="evenodd" /></svg>;
}
;